import {
  createSlice,
  createEntityAdapter,
  PayloadAction,
  EntityState,
} from '@reduxjs/toolkit';
import { Advertiser } from 'core/models';
import { ProcessStatus } from 'states';

export const entityAdapter = createEntityAdapter<Advertiser>({
  selectId: (model) => model.id,
  sortComparer: (a, b) => a.id.localeCompare(b.id),
});

interface AdvertiserState extends EntityState<Advertiser> {
  status: ProcessStatus;
}

const initialState: AdvertiserState = entityAdapter.getInitialState({
  status: 'idle',
});

const slice = createSlice({
  name: 'advertiser',
  initialState,
  reducers: {
    resetStatus(state) {
      state.status = 'idle';
    },
    list(state) {
      state.status = 'loading';
    },
    listSuccess(state, action: PayloadAction<Advertiser[]>) {
      entityAdapter.addMany(state, action.payload);
      state.status = 'success';
    },
    listFailure(state) {
      state.status = 'failure';
    },
  },
});

export const actions = slice.actions;
export default slice;
